module.exports = __webpack_public_path__ + "assets/img/face_check_scene1.08a5436d.png";